import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Survey, Question } from '../../classes';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SurveyService, ChangeDescriptorService } from '../../services';
import { LoadingService } from'@schoolbelle/common/loading';
import { ToastrService } from 'ngx-toastr';
import { focusOn } from './functions/focus-on.fn';
import { scrollTo } from './functions/scroll-to.fn';
import { FormGroup } from '@angular/forms';
import { isIframe } from '../../functions';
import { CrosswindowMessageService } from '@schoolbelle/common/crosswindow-message';

@Component({
  selector: 'app-compose',
  templateUrl: './compose.component.html',
  styleUrls: ['./compose.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class ComposeComponent implements OnInit {

  survey:Survey;
  composeFormGroup:FormGroup;
  subscriptions:Subscription[] = [];
  constructor(
    private surveyService:SurveyService,
    private route:ActivatedRoute,
    private router:Router,
    private loading:LoadingService,
    private toastr:ToastrService,
    private message:CrosswindowMessageService,
    public changeDescriptor:ChangeDescriptorService,
    private cdRef:ChangeDetectorRef,
  ) { 
    this.composeFormGroup = new FormGroup({
      questions:new FormGroup({}),
    });

  }

  ngOnInit() {
    const surveyData = this.route.snapshot.data.surveyData;
    if (surveyData) {
      this.survey = new Survey(surveyData.id, surveyData.type);
      this.survey.load(surveyData)
      this.cdRef.detectChanges();

    } else {
      this.survey = new Survey();
      this.survey.load({private:false, open_at:Date.now(), close_at:Date.now() + 7 * 24 * 60 * 60 * 1000});
      this.addQuestion();
    }
    this.subscriptions.push(this.survey.onContentUpdate.subscribe(()=>{
      // this.changeDescriptor.load(this.survey.origin, this.survey.value);      
      this.cdRef.detectChanges()
    }));
  }
  ngOnDestroy () {
    this.subscriptions.forEach(sub=>sub.unsubscribe());
  }
  addQuestion () {
    let question:Question = this.survey.addQuestion({type:'radio'}, {push:'none'});
    question.addOption({}, {push:'none'});
    question.addOption({}, {push:'none'});
    question.notifyChangeThruTree([]);
    setTimeout(()=>{
      focusOn(`#question_${question.id} textarea`);
      scrollTo(`#question_${question.id} textarea`, 300);
    })


  }
  trackByIdFn(index:number, value:any) {
    return value.id;
  }
  summaryChanges () {
    return this.changeDescriptor.load(this.survey.origin, this.survey.value);
  }
  save () {
    if (this.survey.isChanged) {
      let promise = this.surveyService.write(this.survey);
      promise.then((new_survey_id)=>{
        this.toastr.success('ì ì¥ëììµëë¤.');
        if (isIframe()) {
          const state = this.route.snapshot.queryParams.state;
          this.message.send(window.parent, {message:'saved', data:this.survey.value, state}, '*');
        } else {
          this.router.navigateByUrl(`/compose/${new_survey_id}`);
        }
      })
      this.loading.open({message:'ì ì¥ì¤ìëë¤...', busy:promise});
    }  

  }
}
